import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Home from './pages/Home';
import Shop from './pages/Shop';
import About from './pages/About';
import Systems from './pages/Systems';
import MerchantStore from './pages/MerchantStore';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/products" element={<Systems />} />
          <Route path="/systems" element={<Systems />} />
          <Route path="/about" element={<About />} />
          <Route path="/market" element={<Navigate to="/" replace />} />
          <Route path="/market/:orgId" element={<MerchantStore />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
